import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Rent With Driver Torino | Servizio NCC Premium con Mercedes V-Class",
  description = "Servizio NCC di lusso a Torino con Mercedes Classe V. Trasferimenti aeroportuali, eventi aziendali e tour personalizzati. Disponibile 24/7. Prenota ora!",
  keywords = "NCC Torino, noleggio con conducente Torino, transfer aeroporto Malpensa, Mercedes V-Class Torino, servizio luxury Torino, trasferimenti aeroportuali, NCC Langhe, rent with driver",
  image = "https://rentwithdriver-torino.com/og-image.jpg",
  url = "https://rentwithdriver-torino.com"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Additional SEO */}
      <link rel="canonical" content={url} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Italian" />
      <meta name="geo.region" content="IT-21" />
      <meta name="geo.placename" content="Torino" />
      
      {/* Schema.org markup */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Rent With Driver Torino",
          "description": description,
          "image": image,
          "telephone": "+39 349 462 4648",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Torino",
            "addressRegion": "Piemonte",
            "addressCountry": "IT"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "45.0703",
            "longitude": "7.6869"
          },
          "url": url,
          "priceRange": "€€€",
          "openingHours": "Mo,Tu,We,Th,Fr,Sa,Su 00:00-23:59",
          "areaServed": ["Torino", "Milano", "Malpensa", "Linate", "Bergamo", "Langhe"],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Servizi NCC",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Trasferimenti Aeroportuali",
                  "description": "Transfer da/per aeroporti Malpensa, Linate, Bergamo, Caselle"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Servizi Aziendali",
                  "description": "Trasporti per eventi corporate e meeting di business"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Tour Langhe",
                  "description": "Tour enogastronomici personalizzati nelle Langhe"
                }
              }
            ]
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
